import dayjs from 'dayjs';
import { useMemo } from 'react';

import { getAverage } from 'utils';

type UseTaskTimeParams = {
  minAmount?: string;
  maxAmount?: string;
  minDelay?: number;
  maxDelay?: number;
  totalTokenAmount?: string;
};

export const useTaskTime = ({
  minAmount,
  maxAmount,
  minDelay,
  maxDelay,
  totalTokenAmount,
}: UseTaskTimeParams) => {
  const durationInMs = useMemo(
    () =>
      minAmount && maxAmount && minDelay && maxDelay
        ? Math.round(
            (Number(totalTokenAmount) / getAverage([minAmount, maxAmount])) *
              getAverage([minDelay, maxDelay]),
          )
        : 0,
    [totalTokenAmount, minAmount, maxAmount, minDelay, maxDelay],
  );

  const currentTimeInMs = Math.round(Date.now());
  const finishTimeInMs = durationInMs ? currentTimeInMs + durationInMs : 0;

  const difference = useMemo(
    () => dayjs.duration(dayjs(finishTimeInMs).diff(dayjs())).locale('en').humanize(),
    [finishTimeInMs],
  );

  const finishTimeUiString = useMemo(
    () =>
      !!finishTimeInMs && `${dayjs(finishTimeInMs).locale('en').format('L LT')} (${difference})`,
    [finishTimeInMs, difference],
  );

  return { durationInMs, currentTimeInMs, finishTimeInMs, finishTimeUiString };
};
